<div class="user-card">
  <div class="cover">
    <ng-container *ngTemplateOutlet="cover"></ng-container>
  </div>
  <div class="meta">
    <ng-container *ngTemplateOutlet="meta"></ng-container>
  </div>
</div>

<ng-template #cover>
  <on-ui-cover [cover]="avatar"></on-ui-cover>
</ng-template>

<ng-template #meta>
  <div class="title">
    {{ user.title }}
  </div>
  <div class="description" *ngIf="user.description">
    {{ user.description }}
  </div>
</ng-template>
